import { httpGet } from "@eres/rest";
import { I8N } from "@eres/core";
import cfg from "./config";
import { CasesResponse, ValidationError } from "./entities";

export interface TRResponse<T> {
	isSuccess: boolean;
	recordSet: T;
}

export function getCasesOnProperty( tabuPropertyId: number ): Promise<CasesResponse> {
	return httpGet( cfg.rdcCasesAPI().endPoint() + `cases/` + tabuPropertyId );
}

export function getValidationError( errors: ValidationError[] ) {
	let errorMsg = errors.map( ( error: ValidationError ) => {
		if ( error.errorMessage ) {
			return error.errorMessage;
		} else {
			return I8N.locale() === "ar" ? error.nameAr : error.nameEn;
		}
	} );
	return errorMsg.join( "\n" );
}
